import { Column } from "../objects/column";
import { CorporateCode } from "../objects/corporateCode";
import { CorporateCodeErrors } from "../objects/corporateCodeErrors";
import { CorporateCodeListConfiguration } from "../objects/corporateCodeListConfiguration";
import { CorporateCodeListCriteria } from "../objects/corporateCodeListCriteria";
import { CorporateCodeListFiltersCriteria } from "../objects/corporateCodeListFiltersCriteria";

export const EMPTY_CORPORATE_CODE: CorporateCode = {
    id: 0,
    provider: null,
    code_value: "",
    iata_airport: null,
    created_date: new Date(),
    modified_date: new Date(),
    creator: null,
    last_author: null,
    is_secondary: false,
    client_branch: null
};

export const EMPTY_CORPORATE_CODE_FILTERS: CorporateCodeListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    iata_airport: null
};

export const EMPTY_CORPORATE_CODE_LIST_CRITERIA: CorporateCodeListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_CORPORATE_CODE_FILTERS,
    search: '',
    client_branch: null
};

export const EMPTY_CORPORATE_CODE_ERRORS: CorporateCodeErrors = {
    code_value_error: "",
    provider_error: ""
};

export const CORPORATE_CODE_INFO_ROUTE = '/corporate-code/edit/:id/info';
export const CORPORATE_CODE_CONTACT_ROUTE = '/corporate-code/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'provider',
    field_name: 'PROVIDER',
    checked: true,
    order_by: 'provider',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'code',
    field_name: 'CODE_VALUE',
    checked: true,
    order_by: 'code_value',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'is-secondary',
    field_name: 'IS_SECONDARY',
    checked: true,
    order_by: 'is_secondary',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'destination-airport',
    field_name: 'AIRPORT',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_CORPORATE_CODE_LIST_CONFIGURATION: CorporateCodeListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const CORPORATE_CODE_MODULE = 'CORPORATE_CODE';
